import ReactGA from "react-ga4";
export const initializeGA = () => {
	ReactGA.initialize([
		{
			trackingId: process.env.REACT_APP_GTAG,
		},
	]);
};
